import { ReactNode } from 'react'

import { useAuth } from '@features/auth'

import { URL_MAIN_PAGE } from '@shared/contants'
import { LocalizedNavigate as Navigate } from '@shared/lib/locale'

export default function PrivateRoute ({ children }: { children: ReactNode }) {
  const { isAuthorized, loading } = useAuth()

  if (!loading && !isAuthorized) {
    return <Navigate to={URL_MAIN_PAGE} />
  }

  return children
}
